import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { NomineeType } from '../types';
import { getVideoArticleAsset } from '../utils/utils';

export const useVideoAspectRatio = (nominee: NomineeType) => {
  const {
    i18n: { language },
  } = useTranslation();
  const videoAsset = useMemo(() => getVideoArticleAsset(nominee, language), [language, nominee]);
  const format = useMemo(() => {
    const width = parseInt(videoAsset?.size?.width);
    const height = parseInt(videoAsset?.size?.height);

    // is wide
    if (isNaN(width) || isNaN(height) || width > height) return 'WIDE';

    return 'SQUARE';
  }, [videoAsset?.size?.height, videoAsset?.size?.width]);

  const aspectratio = format === 'WIDE' ? '16:9' : '1:1';
  const stretching: 'uniform' | 'exactfit' = format === 'WIDE' ? 'uniform' : 'exactfit';

  return { format, aspectratio, stretching };
};
